<!--<p-card>-->
<!--  <div class="card-size">-->
<!--  <p-tabMenu [model]="ppStatuts"></p-tabMenu>-->
  <router-outlet></router-outlet>
<!--  </div>-->
<!--</p-card>-->

